import { makeStyles } from "@material-ui/core";

export const useFilterChipsStyles = makeStyles(() => ({
  buttons: {
    display: "flex",
    "align-items": "center",
    "justify-content": "flex-end",
  },
  chip: {
    margin: "0 10px 10px 0",
    "&:focus, &:hover": {
      filter: "brightness(120%)",
    },
  },
  chips: {
    display: "flex",
    "align-items": "center",
    "justify-content": "space-between",
    "margin-right": "50px",
  },
  filtersWrapper: {
    display: "flex",
    "align-items": "center",
    "justify-content": "space-between",
    "margin-bottom": "15px",
  },
}));
